<template><div class="view">

	<main v-if="influencer">

		<div class="img">
			<img :src="bg_src" alt="">	

			<div class="generic-add-to-casting-btn" @click="add_to_casting($event)">
              Add to package
            </div>

		</div>

		<fetching-content v-if="is_fetching_content" />
		<error-404 v-if="!influencer && !is_fetching_content" />	
			
		
		<blocks v-if="!editing_blocks" :blocks="book_blocks" :metadata="{influencer,book}" />
		<block-editor v-if="editing_blocks" :blocks="book_blocks" :route_name="$route.name" :influencer="influencer" :book_slug="book" @updated="blocksUpdated()" />

	</main>

</div></template>
<script>
import helpers from '.././helpers.js'
import mixins from '.././mixins.js'
import Blocks from '.././components/Blocks'
import BlockEditor from '.././views/admin/AdminBlockEditor'

export default {
	
	mixins: [ mixins.generic ],
	
	components: { 		
		Blocks, 
		BlockEditor, 
	},

	data(){ return {


	}},

	computed: {

		slug(){ return this.route.params.slug },

		book(){
			var book = this.route.params.book
			if( !book ) book = 'portfolio'
			return book
		},

		influencer(){ return this.$store.state.loaded_influencer },

		book_blocks(){
			if( !this.book ) return
			if( !this.influencer ) return			
			if( !this.influencer.books ) return

			var book_slug = this.book
			if( this.book == 'full-book' ) book_slug = 'portfolio'

			if( !this.influencer.books[book_slug] ) return
			
			var blocks = this.influencer.books[book_slug].blocks
			
			if( this.book == 'portfolio' && !this.editing_blocks) {
				blocks = blocks.slice( 0, 8 )
			}

			if( this.book == 'full-book' ) {
				// change blocks to 1-1
				blocks = helpers.rearrange_blocks( '1-1', blocks )
			}
			
			return blocks
		},

		bg_src(){
			
			if( !this.influencer ) return
			if( !this.influencer.bio_img_id ) return

			return this.mediaUrl( this.influencer.bio_img_id, 2500 )
			
		},

		
		bg_css(){
			var css = {}
			if( this.bg_src ) css['background-image'] = 'url('+ this.bg_src +')'
			return css
		},

	},

	methods: {

		load_influencer(){
			
			var _this = this

			_this.$store.commit('set_loaded_influencer', undefined )

			this.fetch( 'get_influencer', { slug:this.slug }, 
			{ onSuccess: function(output){
				
				if( !output.data || !output.data.influencer ) {
					console.log('valid request, but missing data')												
					return
				}

				_this.$store.commit('set_loaded_influencer', output.data.influencer )
				_this.setDocumentTitle( output.data.influencer.full_name )
				window.prerenderReady = true

			}, onError: function(output){

				console.log('NAH - fetched but with error',output)		

			}})
				
		},
		

		blocksUpdated(){
			this.load_influencer()
		},


		add_to_casting( event, media ){
      
			var item = {
				media_id: this.influencer.bio_img_id,
				influencer_id: this.influencer.id,
			}
			
			this.casting_item_add(item)

			// visual feedback
			var origtext = event.target.innerHTML
			event.target.innerHTML = '· · ·'

			setTimeout(function(){
				event.target.innerHTML = 'Added'
			}, 250)
			
			setTimeout(function(){
				event.target.innerHTML = origtext
			}, 1000)

			document.querySelector('.package-minimenu').classList.add('lookatme')
			setTimeout(()=>{ document.querySelector('.package-minimenu').classList.remove('lookatme') },1000)

		},

	},

	watch: {
		'$route' (to, from) {
			
			//this.load_influencer()

			//window.scrollTo( 0, 0 )


		}
	},
	
	mounted(){
		this.load_influencer()
	},

	created(){
	},

}
</script>



// WEBPACK FOOTER //
// src/views/InfluencerSingle.vue